<script>
    import { onMount } from "svelte";
    import { store } from '../../store.js';
    import Typewriter from "svelte-typewriter";

    export let onClick = null;
    export let href = '/';
    export let text = 'button';
    export let styles = { width: 0, height: 0};
    export let hide = true;
    export let cursor = false;
    export let typewriter = false;
    export let logo = false;

    function style(node, initialVars) {
        let oldVars;

        function applyStyles(vars) {
            if (typeof vars === 'string') {
                if (!oldVars && !vars) {
                    // Do nothing if it's an empty string;
                    return;
                }

                node.style.cssText = vars;
                oldVars = vars;
                return;
            }

            vars = vars || {};
            for (let [k, v] of Object.entries(vars)) {
                if(!isNaN(v)) {
                    v = `${v * $store.r}px`;
                }
                node.style.setProperty(k, v);
            }

            for (let k of Object.keys(oldVars || {})) {
                if (!(k in vars)) {
                    // In the DOM, setting it to an empty string actually deletes it.
                    node.style.setProperty(k, '');
                }
            }

            oldVars = vars;
        }

        applyStyles(initialVars);

        return {
            update(newVars) {
            applyStyles(newVars);
            },
        };
    }
</script>
<div class="button-wrapper">
    <button 
        on:click={ () => {
            if($store.isDev) return;
            if(typeof onClick === 'function') return onClick();
            location.href = `/${$store.locale}${href}`;
            return;
        }}
        type="button" 
        class:hide
        use:style={styles}
    >
        <div>
            {#if typewriter}
            <Typewriter cascade interval={100} loop={false} cursor={false}>
                <span>{text}</span>{#if cursor}<span class="blink">_</span>{/if}
            </Typewriter>
            {:else}
                <span>{text}</span>{#if cursor}<span class="blink">_</span>{/if}
            {/if}
            {#if logo}
                <span class="text-arrow">>></span>
            {/if}
        </div>        

        {#if logo}
            <img src="/images/button-logo.png" alt="KCT-Konnect" style={`width: ${(styles.height - 20) * $store.r}px`} />
        {/if}
        
    </button>
</div>


<style>
    .hide {
        opacity: 0;
    }

    .text-arrow {
        letter-spacing: -5px;
    }

    .button-wrapper {
        padding: 15px;
        overflow: hidden;
        border-radius: 100px;
        background: linear-gradient(357deg, #ffffff 0%, #ffffff 25%, rgb(229 231 231) 100%);
    }

    .button-wrapper button {
        background: linear-gradient(337deg, #ffffff 0%, #ffffff 25%, rgb(229 231 231) 100%);
        border: 3px solid rgb(255 255 255 / 90%);
        border-radius: 100px;
        box-shadow: 0px 5px 10px rgb(0 0 0 / 10%);

        font-family: roboto;
        font-size: 1.6vw;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }

    @media only screen and (max-width: 640px) {
        .button-wrapper button {
            font-size: 3vw;
        }
    }

</style>